import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router, ActivationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

declare function changeCookiesLanguage(lang: string): any;

@Injectable({ providedIn: 'root' })
export class LanguageService {
  get onChangeLanguage() {
    return this.language$.asObservable();
  }
  readonly language$ = new BehaviorSubject<string>('');

  constructor(
    private localeService: BsLocaleService,
    public translate: TranslateService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  public setLanguage(lang: string) {
    if (lang) {
      if (this.document.documentElement.lang !== lang) {
        this.document.documentElement.lang = lang;
      }
      // if (!!changeCookiesLanguage) {
      //   changeCookiesLanguage(lang);
      // }
    }
    this.localeService.use(lang);
    this.translate.use(lang);
    this.language$.next(lang);
  }
  public instant(obj: string, params?: any): string | any {
    return this.translate.instant(obj, params);
  }

  public instantAsync(obj: string) {
    return this.translate.get(obj);
  }
  public getCurrentLanguage() {
    return this.language$.value;
  }
  public getTranslations(lang: string, key: string) {
    return new Observable((observer) => {
      this.translate.getTranslation(lang).subscribe(() => {
        const data = this.translate.getParsedResult(
          this.translate.translations[lang],
          key
        );
        observer.next(data);
        observer.complete();
      });
    });
  }
  get translationsLoaded(): Observable<boolean> {

    if (this.translate.store.translations[this.translate.currentLang]) {
      return of(true);
    } else {
      return this.translate.onLangChange
        .pipe(
          map(res => !!res)
        );
    }
  }
}
